const BREAKPOINTS = {
  DESKTOP: 1024,
  DESKTOP_LARGE: 1280
};

const SETTINGS = {
  THROTTLE_DELAY_SMALL: 50,
  THROTTLE_DELAY: 500,
  SEARCH_DEBOUNCE_DELAY: 300,
  MINICART_DEBOUNCE_DELAY: 300,
  FILTER_UPDATE_DELAY: 250,
  FILTER_DRAW_ANIMATION_TIME: 300,
  MOBILE_HEADER_STICKY_SCROLL_THRESHOLD: 100,
  NAV_CLOSE_DELAY: 300
};

const CART = {
  FORM_SUBMIT_TIMEOUT: 2000,
  BUNDLE_POLL_INTERVAL_MS: 500,
  BUNDLE_POLL_MAX_TRIES: 20
};

const PRODUCT_RECENTLY_VIEWED = {
  MINIMUM_PRODUCTS_TO_SHOW: 3,
  MAX_CONTENT_CHARS_AMOUNT: 26
};

const CLASSES = {
  TRANSLATE_X_0: 'translate-x-0',
  TRANSLATE_X_100: 'translate-x-full',
  OVERFLOW_HIDDEN: 'overflow-hidden',
  SCROLLABLE: 'overflow-y-auto',
  TRANSPARENT_HEADER: 'transparent-header',
  HEADER_OPAQUE: 'header-opaque'
};

const ARIAS = {
  EXPANDED: 'aria-expanded'
};

const SWIPER = {
  SLIDE_CLASS: '.swiper-slide'
};

const WISHLIST = {
  APP_ADDED_CLASSES: ['unbookmarked', 'bookmarked', 'sw_tooltip', 'tooltip', 'tooltipstered']
};

const SELECTORS = {
  LOADING_SPINNER: '[data-loading-spinner]',
  NAVIGATION_CLOSE: '[data-navigation-close]',
  NAVIGATION_MENU_2: '[data-navigation-menu="2"]',
  HAMBURGER_TOGGLE: '[data-hamburger-toggle]'
};

export {
  BREAKPOINTS,
  SETTINGS,
  CART,
  PRODUCT_RECENTLY_VIEWED,
  CLASSES,
  ARIAS,
  SWIPER,
  WISHLIST,
  SELECTORS
};
